import React, { useState } from 'react'
import { graphql, Link } from "gatsby";
import { Helmet } from 'react-helmet'
import Header from '../components/header'
import { ExpandMore } from "@material-ui/icons";
import {
    Accordion,
    AccordionSummary,
    AccordionDetails
} from "@material-ui/core";
import ReactGA from 'react-ga'
import InstituteTabs from "../components/institutiontabs";
import { TabPanel, Tabs } from 'react-tabs';
import ScrollAnimation from 'react-animate-on-scroll';
import '../css/programs-page.css'
import Footer from '../components/footer';
import cardImg from '../images/programs/degree.svg'
import cardImg1 from '../images/programs/start online.svg'
import cardImg2 from '../images/programs/get your visa.svg'
import cardImg3 from '../images/programs/completed overseas.svg'
import unismarterImage1 from '../images/programs/unlimited choices.svg'
import unismarterImage2 from '../images/programs/exclusive scholarships copy.svg'
import unismarterImage3 from '../images/programs/choose your career path.svg'
import unismarterImage4 from '../images/programs/save time and trouble.svg'
import bussinessImag from '../images/programs/Business.png'
import commerseImag from '../images/programs/Commerce.png'
import computerImage from '../images/programs/ComputerScience.png'
import marketingImage from '../images/programs/Marketing.png'
import sportsImage from '../images/programs/Sports.png'
import filmStudiesImage from '../images/programs/filmstudies.png'
import EngineeringImage from '../images/programs/engineering.png'
import scienceImage from '../images/programs/science.png'
import sampleOfferImage from '../images/programs/sample offer letter.png'
import "../css/sharan-style.css";
import "../css/animate.min.css";
import "../css/style.css";
import UniversityCardView from '../components/UniversityCardView';
import PartnerUniAmericaSlider from '../components/PartnerUniAmericaSlider';
import { BsFillCircleFill } from 'react-icons/bs';
import AmericanDreamRequirements from '../components/AmericanDreamRequirements';
import FaqSection from '../components/FAQSection';
import AmericanDreamFaqSection from '../components/AmericanDreamFaqSection';

const AmericanDream = (wpUniData) => {

    const uniArr = wpUniData.data.allWordpressWpUniversities.nodes
    
    const [value, setValue] = React.useState(0);
    const [cardData, setCardData] = useState([
        {
            image: cardImg, title: "Choose Your Degree", text: "Get admission to a top US university in a stream of your choice - business, arts, engineering, technology and more"
        },
        {
            image: cardImg1, title: "Start Online", text: "Complete the first year of your degree online in just 10 months (6-8 credits per 7 week study period) and receive a transcript from a US university"
        },
        {
            image: cardImg2, title: "Get Your Visa", text: "Complete your visa process while studying and be ready to go to the US by the end of the All American Year 1 program."
        },
        {
            image: cardImg3, title: "Complete Overseas", text: "Progress to the overseas campus to complete the remainder of your degree and apply for post study work rights."
        }
    ])
    const [coursesGridData, setCoursesGridData] = useState([
        {
            image: bussinessImag, text: "Business & Management", gridR: "1/2", gridC: "1/2",gridRM:'1/2',gridCM:'1/4'
        },
        {
            image: commerseImag, text: "Commerce & Finance", gridR: "1/2", gridC: "2/3",gridRM:'2/3',gridCM:'1/4'
        },
        {
            image: marketingImage, text: "Marketing", gridR: "2/3", gridC: "1/2",gridRM:'4/5',gridCM:'1/4'
        },
        {
            image: filmStudiesImage, text: "Film Studies", gridR: "2/3", gridC: "3/4",gridRM:'6/7',gridCM:'1/4'
        },
        {
            image: EngineeringImage, text: "Engineering", gridR: "3/4", gridC: "1/2",gridRM:'7/8',gridCM:'1/4'
        },
        {
            image: sportsImage, text: "Sports Management", gridR: "2/3", gridC: "2/3",gridRM:'5/6',gridCM:'1/4'
        },
        {
            image: scienceImage, text: "Science", gridR: "3/4", gridC: "2/3",gridRM:'8/9',gridCM:'1/4'
        },
        {
            image: computerImage, text: "Computer Science & Information Technology", gridR: "1/2", gridC: "3/4",gridRM:'3/4',gridCM:'1/4'
        }
    ])
    const [collapse, setCollapse] = useState([
        {
            title: "Business Writing - 3 credits",
            body: "This course develops the writing and communications skills needed for success in business with an emphasis on basic mechanics formatting, and persuasive techniques. The course focuses on practical experience writing business reports, letters, memoranda, executive summaries proposals, and presentations as well as reading comprehension, the cornerstone of clear writing."
        },
        {
            title: "Business Foundations and Analysis - 3 credits",
            body: "An analytical survey of the principles and skills necessary for accounting, economics, marketing finance, human resources, management, and government policies as they apply to business in the United States and globally. Through the course students develop a framework for analyzing business issues and develop critical thinking skills to solve organizational problems. This course will include an introduction of the case method."
        },
        {
            title: "Accounting Principles I - 4 credits",
            body: " Course emphasis is on the measurement, valuation and the accumulation of accounting data. Topics include the accounting cycle through financial statements, accounting for merchandise, internal control, notes, bad debts, inventories and accounting for tangible and intangible assets. Focus is on the sole proprietorship. Faculty-guided lab experiences are provided for additional reinforcement of course concepts."
        },
        {
            title: "Accounting Principles II - 4 credits",
            body: "Course emphasis is on the measurement, valuation and the accumulation of accounting data. Topics include accounting for partnerships, corporations bonds, cash flow statements, present value annuities and financial statement analysis. Faculty guided experiences are provided for additional reinforcement of course concepts."
        },
        {
            title: "Microeconomics - 3 credits",
            body: "An exploration of the economic affairs of industries and the individual business firm. This course introduces the price system, the law of supply and demand and economic analysis of individual markets such as labor or international trade."
        },
        {
            title: "Macroeconomics - 3 credits",
            body: "An introductory analysis of the aggregate economic system. This course discusses methods of recording and determining gross national product employment, price stability, fiscal and monetary policy."
        },
        {
            title: "Freshman English I - 3 credits",
            body: "Completion with a grade of C (2.0) or better fulfills the Written Communication requirement for the Associate and Baccalaureate degree. Principles and practice of writing with attention to analytical reading. Includes discussion skills, library usage, research techniques, and an introduction to literature."
        },
        {
            title: "Freshman English II - 3 credits",
            body: "Completion with a grade of C (2.0) or better fulfills the Written Communication requirement for the Associate and Baccalaureate degree. Principles and practice of writing with attention to analytical reading. Includes discussion skills, library usage, research techniques, and an introduction to literature."
        },
        {
            title: "Writing For College - 3 credits",
            body: "Preparation for college-level English, with a focus on standard written English, expository writing, and analytical reading. Prerequisite: Score of 3 or better on Writing Placement test plus satisfactory scores on the English entrance exams in grammar and reading."
        },
        {
            title: "Introduction to Communication - 2 credits",
            body: "Introduction to basic principles of communication theory in both small and large groups together with practice in discussion and speech delivery."
        },
        {
            title: "Professional Development and Presentations - 3 credits",
            body: "This course is designed to assist students develop creative approaches to launching a career. The student will identify appropriate elements necessary to make their resume stand out. Students will also identify the most effective ways a cover letter can answer a job description, and how to best leverage social media in a job search. The student will learn how to apply, network, leverage social media, interview, follow-up, and evaluate options through research and practice. Additionally, actively improving communication skills plays an important role in the process of personal development and career progression. The student will develop the skills to communicate their message clearly. Effective communication involves speaking, visual presentations, and listening."
        },
        {
            title: "World Economic History - 3 credits",
            body: "This course will offer a unified explanation for the growth of Western Europe from AD 900 to 1900 with particular emphasis on the evolution of economic institutions. These institutions include property rights, banking and credit, public finance, forms of business organizations and wage labor."
        },
        {
            title:"Global Culture and Business - 3 credits",
            body: "This course emphasizes the critical nature of culture in global business. The concept of globalization fosters the understanding of the interconnectedness of cultures and societies geographically wide apart. Students will gain greater awareness of cultural sensitivities needed for success within the domestic work environment, but also within growing global markets. The course offers a platform for analysis and discussion of the role culture plays, and the consequences which can ensue when it is not understood, or respected, in the global business environment. Cultural dimensions include context, individualism, formality, communication style, and time/space orientation, and their roles within the business environment. Through case studies in global culture, students will analyze, and pose solutions to critical cultural problems in international business, while also further developing critical thinking skills."
        },

    ])

    const [collapse2,setCollapse2]=useState([
        {
            title:"Financial Accounting/Analysis of the accounting process - 3 credits",
            body: "This course is designed to develop the student’s ability to analyze and record accounting transactions, prepare financial statements, and analyze accounting information for decision-making."
        },
        {
            title:"Business Law I - 3 credits",
            body: "An examination of civil and criminal law and process and their interrelationship. The course also examines application of the Constitution to business with particular emphasis on the court system and administrative agencies. Substantively, the content areas of torts and contracts will be examined."
        },
        {
            title:"Principles Of Microeconomics - 3 credits",
            body: "A study of microeconomics (the “parts” of the economy), concepts and principles, international trade, and current issues in microeconomics."
        },
        {
            title:"Introduction to Speech Communication - 3 credits",
            body: "Introduction to Speech Communication is a course in spoken communication that emphasizes interpersonal, group, and public communication. Two speeches, a group presentation, a series of practical exercises and tests are required of all students."
        },
        {
            title:"Digital Literacy and Technology Readiness - 3 credits",
            body: "This course is designed to provide students with sustainable and usable skills essential to success in both academic and professional settings. Students will analyze the impact of digital technology on personal and social communication to develop digital literacy skills. Students will explore security, privacy, and ethical issues related to the current digital environment. Finally, the course discusses the use of productivity software as a means of effective information creation, communication collaborations and analysis."
        },
        {
            title:"Introduction to Operating Systems - 3 credits",
            body: "This course provides the student with extensive hands-on exposure to Windows and non-MS Windows environments. Included are such topics as interface design, disk and memory management, system configurations, multitasking, data sharing, and the network environment. Multiplatform operating systems will be introduced."
        },
        {
            title:"Networking Fundamentals - 3 credits",
            body: "This course provides an overview of network hardware, operating systems, and applications with a focus on design, implementation and management of the network environment inside an organization."
        },
        {
            title:"Internet and Website Design - 3 credits",
            body: "Topics covered are the Internet and its parts, such as the World Wide Web and website development. The student will learn to create web sites using the current tools, such as Notepad++ or another development environment along with languages such as HTML, JavaScript, and CSS for the internet, intranets and extranets."
        },
        {
            title:"Database I - 3 credits",
            body: "This course addresses technologies for developing database applications. It covers the principles of database design and database models, using database software. Organizational data modeling and designing normalized database structures is strongly emphasized. Managerial issues associated with database administration are covered along with an introduction to distributed database concepts in a client-server environment. The course will expose the student to the Structured Query Language (SQL)."
        },
        {
            title:"Rhetoric and Introductory Research Writing - 3 credits",
            body: "This course prepares students for academic writing and research. Students will develop skills in summary, synthesis, and argument writing and will be introduced to college research. They may be taught these skills through a variety of rhetorical modes (pro/con, cause/effect, comparison/contrast, etc.) and/or through rhetorical analysis (ethos, logos, and pathos). Emphasis is placed on developing essays characterized by strong thesis statements; focused, coherent, and logically ordered paragraphs; correct grammar; and correct documentation in APA style"
        },
        {
            title:"Introductory Marketing - 3 credits",
            body: "This course exposes the student to the vocabulary of marketing and introduces many of the major principles and theories of the discipline. The focus of the course is on marketing’s relationship to the other business functions and on marketing function management as opposed to day-to-day marketing operations."
        },
        {
            title:"College Algebra - 3 credits",
            body: "The course topics include functions and graphs, polynomial and rational functions, exponential and logarithmic functions, matrices, and sequences."
        },
        {
            title:"Quantitative Reasoning - 3 credits",
            body: "Students will create, analyze and interpret basic mathematical models from informal problem statements, argue that the models constructed are reasonable, and use the models to provide insight into the original problem. Life-long critical thinking and quantitative reasoning skills will be taught."
        },
        {
            title:"Introduction to Psychology - 3 credits",
            body: "Introduction to psychology as a behavioral science, including historical background, human development (genetic and physical) from birth through death, the senses and perception, intelligence and creativity, and the principles of conditioning, learning, memory, and forgetting."
        },
        {
            title:"Introduction to the American Political Process - 3 credits",
            body: "A survey course that covers the American democratic process and the distribution of authority and responsibility between the federal, state, and local levels."
        },
        {
            title:"Principles of Sociology - 3 credits",
            body: "Introduction to the basic concepts of sociological study, elements of social life, social patterns and institutions, and the process of maintenance and change in society"
        },
    ])

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <>
        <div className="program-page" style={{fontFamily: 'caros'}}>
            <Helmet>
                <title>
                    American Dream | The WorldGrad
                </title>
                <meta
                    name="description"
                    content="Get answers to all your study abroad questions on topics like  like, program options to choose from, pros and cons of different countries, student visa application process, how to finance your overseas education, most value for money universities, entry requirement to get into a good university and much more in The WorldGrad study resources section." />
                <meta
                    name="keywords"
                    content="study abroad, study overseas, educations courses, student visas, universities" />
                <link rel="icon" href="https://res.cloudinary.com/worldgrad/image/upload/v1612961357/worldgrad/twg_favicon_ymgrbw.png" />

            </Helmet>
            <Header />
            
            <div className="container-fluid american-dream-banner-section mt-md-3 d-flex justify-content-center align-items-center">
                <div className="row">
                    <div className="col-12">
                        <p className='text-muted american-dream-breadcrumb'>
                            Programs - <p className='american-dream-breadcrumb-alt'> All American Year 1 Program </p> 
                        </p>
                    </div>
                    <div className="col-12">
                        <h1 className='text-center' style={{color: "#fff"}}>
                            All American Year 1 Program
                        </h1>
                    </div>
                    <div className="col-12">
                        <h5 className='text-center pt-md-4 american-dream-banner-subtext'>
                            Get access to over 4000 universities in the US with exclusive scholarships at top ranked WorldGrad partner universities 
                        </h5>
                    </div>
                </div>
            </div>

            <div className="section py-5" style={{backgroundColor: "#f8f8fa"}}>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <h4 className='american-dream-section-one-heading' style={{textTransform: "uppercase"}}>
                                Start online with the All American Year 1 Program and progress to a top-ranked US university  
                            </h4>
                        </div>
                        <div className="col-12">
                            <h6 className='american-dream-section-one-subtext'>
                                The All American Year 1 Program allows Indian students to complete the first year, i.e. 30 credits of their undergraduate degree online at home before progressing to one of our top-ranked partner universities to continue their education at the university campuses, i,e. from year 2 onwards.
                            </h6>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container py-5">
                <div className="row">
                    <div className="col-12 text-center">
                        <h3>
                            Our Program Partners
                        </h3>
                        <h6 className='american-dream-subtext'>
                            The university credits are issued by our partners Mount Saint Mary’s University and Tiffin University
                        </h6>
                    </div>
                </div>
                <div className="row align-items-center justify-content-around px-md-5">
                    {/* <img style={{width: "250px", margin: "20px"}} src="https://media.publit.io/file/TheWorldgrad/UniversityLogosCommon/TiffinU-logo_horiz_green_black.webp" alt="" />
                    <img style={{ width: "250px", margin: "20px" }} src="https://media.publit.io/file/TheWorldgrad/UniversityLogosCommon/Finalmount.png" alt="" /> */}
                    <img
                        src="https://media.publit.io/file/TheWorldgrad/UniversityLogosCommon/6.png" alt=""
                        class="img-fluid mb-5 mb-md-3 d-flex mx-auto shadow p-1"
                        style={{ borderRadius: "15px", width: "250px" }}
                    />
                    <img
                        src="https://media.publit.io/file/TheWorldgrad/UniversityLogosCommon/1.png" alt=""
                        class="img-fluid mb-3 d-flex mx-auto shadow p-1"
                        style={{ borderRadius: "15px", width: "250px" }}
                    />
                </div>
            </div>

            <section style={{backgroundColor: "#f8f8fa"}}>
                <div className="container pt-5 pb-5 pb-md-0">
                    <div className="row">
                        <div className="col-12 text-center mb-4">
                            <h3>The WorldGrad Journey </h3>
                        </div>
                    </div>
                    <div className="row justify-content-between">
                        <div className="col-md-5 mb-3 mb-md-0">
                            <div className="col-12">
                                <a href="/all-american-year1-program">
                                    <h5 className='worldgrad-journey-heading' style={{ color: "#FCB017" }}>
                                        Year 1 : All American Year 1 Program
                                    </h5>
                                </a>

                            </div>
                            <div className="col-12">
                                <h6 className='worldgrad-journey-content'>
                                    Program Provider - The WorldGrad (24-30 Credits Issued by Tiffin University & MSMU)
                                </h6>
                                <img className='react-icon-arrow-desktop' src="https://media.publit.io/file/TheWorldgrad/4Countries/Banner/right-arrow-2.png" alt="" />
                                <h6 className='worldgrad-journey-content'>
                                    Study Mode - Online
                                </h6>
                                <img className='react-icon-arrow-phone' src="https://media.publit.io/file/TheWorldgrad/4Countries/Banner/right-arrow-2.png" alt="" />
                            </div>
                        </div>
                        <div className="col-md-5">
                            <div className="col-12">
                                <h5 className='worldgrad-journey-heading'> Year 2, 3, 4 :  Bachelor Degree </h5>
                            </div>
                            <div className="col-12">
                                <h6 className='worldgrad-journey-content'> Course Provider - Top Ranked US University (Remaining 90 credits issued by the university for degree completion) </h6>
                                <h6 className='worldgrad-journey-content'> Study Mode - On Campus </h6>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div className="container py-5">
                <PartnerUniAmericaSlider />
            </div>

            <section className="american-dream-card-section py-5">
                <div className="container">
                    <div className="row mb-3">
                        <div className="col-12 text-center">
                            <h3 style={{lineHeight: "40px"}}>Why Is the All American Year 1 Program The Right Choice For You</h3>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6 mb-4">
                            <div className="card american-dream-main-card">
                                <div className="card-body">
                                    <div className="row align-items-center">
                                        <div className="col-3 d-flex justify-content-center">
                                            <img src={unismarterImage1} className="unismarted-card-logo-1" />
                                        </div>
                                        <div className="col-9 px-md-5">
                                            <h5> Unlimited Choices </h5>
                                            <p classname="american-dream-card-text">
                                                The credits earned during the All American Year 1 program are recognized by over 4000 universities in the US. Choose from one of our partner universities or transfer credits to a university of your choice 
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 mb-4">
                            <div className="card american-dream-main-card">
                                <div className="card-body">
                                <div className="row align-items-center">
                                        <div className="col-3 d-flex justify-content-center">
                                            <img src={unismarterImage2} className="unismarted-card-logo-1" />
                                        </div>
                                        <div className="col-9 px-md-5">
                                            <h5> Exclusive Scholarships </h5>
                                            <p classname="american-dream-card-text">
                                                Get exclusive scholarships at our partner universities in addition to Year 1 savings on tuition fees and living expenses
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 mb-4">
                            <div className="card american-dream-main-card">
                                <div className="card-body">
                                <div className="row align-items-center">
                                        <div className="col-3 d-flex justify-content-center">
                                            <img src={unismarterImage3} className="unismarted-card-logo-1" />
                                        </div>
                                        <div className="col-9 px-md-5">
                                            <h5> Choose Your Career Path </h5>
                                            <p classname="american-dream-card-text">
                                                The liberal arts and the STEM streams can lead to a variety of majors and minors across all US universities. Major in business, engineering, psychology or even film studies to create the path to your dream career 
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 mb-4">
                            <div className="card american-dream-main-card">
                                <div className="card-body">
                                <div className="row align-items-center">
                                        <div className="col-3 d-flex justify-content-center">
                                            <img src={unismarterImage4} className="unismarted-card-logo-1" />
                                        </div>
                                        <div className="col-9 px-md-5">
                                            <h5> Save Time And Trouble </h5>
                                            <p classname="american-dream-card-text">
                                                No IELTS or Visa required to start the program. Start right away while you prepare to move overseas
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            
            <div className='container-fluid american-dream-top-courses py-5'>
                <div className="row mb-2 mb-md-4">
                    <div className="col-12">
                        <h3 className='text-center'> Top Courses In The US </h3>
                    </div>
                    <div className="col-12 d-flex align-items-center">
                        <BsFillCircleFill size={7} className='mb-2 mb-md-3 mr-2' /> <h5 className='mb-2 mb-md-3' style={{ color: "#000" }}>Bachelor of Science in Computer Science</h5>
                    </div>
                    <div className="col-md-4 mb-2 mb-md-0 d-flex align-items-center justify-content-md-start">
                        <img
                            src="https://media.publit.io/file/TheWorldgrad/3Institutions/Common/Masters-UGPG.png"
                            className='mr-2'
                            style={{ width: "30px" }}
                            alt=""
                        />
                        <p style={{ color: "#465060" }} className='m-0 course-section-orange-text'>
                            New York Institute Of Technology
                        </p>
                    </div>
                    <div className="col-md-4 mb-2 mb-md-0 d-flex align-items-center justify-content-md-center american-dream-course-section">
                        <img
                            src="https://media.publit.io/file/TheWorldgrad/3Institutions/Common/Duration.png"
                            className='mr-2'
                            style={{ width: "30px" }}
                            alt=""
                        />
                        <p style={{ color: "#465060" }} className='m-0 course-section-orange-text'>
                            Course Duration - 4 years
                        </p>
                    </div>
                    <div className="col-md-4 mb-2 mb-md-0 d-flex justify-content-md-end">
                        <a
                            className='course-section-orange-text'
                            href="/program-detail/australia/la-trobe-university/ug/bachelor-of-business-international-business/"
                            // href={course.course_link}
                        >
                            View Details
                        </a>
                    </div>
                    <hr className='course-section-horizontal-line' />
                </div>
                <div className="row mb-2 mb-md-4">
                    <div className="col-12 d-flex align-items-center">
                        <BsFillCircleFill size={7} className='mb-2 mb-md-3 mr-2' /> <h5 className='mb-2 mb-md-3' style={{ color: "#000" }}>Bachelor of Science in Information Technology
                        </h5>
                    </div>
                    <div className="col-md-4 mb-2 mb-md-0 d-flex align-items-center justify-content-md-start">
                        <img
                            src="https://media.publit.io/file/TheWorldgrad/3Institutions/Common/Masters-UGPG.png"
                            className='mr-2'
                            style={{ width: "30px" }}
                            alt=""
                        />
                        <p style={{ color: "#465060" }} className='m-0 course-section-orange-text'>
                            New York Institute Of Technology
                        </p>
                    </div>
                    <div className="col-md-4 mb-2 mb-md-0 d-flex align-items-center justify-content-md-center american-dream-course-section">
                        <img
                            src="https://media.publit.io/file/TheWorldgrad/3Institutions/Common/Duration.png"
                            className='mr-2'
                            style={{ width: "30px" }}
                            alt=""
                        />
                        <p style={{ color: "#465060" }} className='m-0 course-section-orange-text'>
                            Course Duration - 4 years
                        </p>
                    </div>
                    <div className="col-md-4 mb-2 mb-md-0 d-flex justify-content-md-end">
                        <a
                            className='course-section-orange-text'
                            href="/program-detail/australia/la-trobe-university/ug/bachelor-of-business-international-business/"
                            // href={course.course_link}
                        >
                            View Details
                        </a>
                    </div>
                    <hr className='course-section-horizontal-line' />
                </div>
                <div className="row mb-2 mb-md-0">
                    <div className="col-12 d-flex align-items-center">
                        <BsFillCircleFill size={7} className='mb-2 mb-md-3 mr-2' /> <h5 className='mb-2 mb-md-3' style={{ color: "#000" }}> BSc In Business Administration</h5>
                    </div>
                    <div className="col-md-4 mb-2 mb-md-0 d-flex align-items-center justify-content-md-start">
                        <img
                            src="https://media.publit.io/file/TheWorldgrad/3Institutions/Common/Masters-UGPG.png"
                            className='mr-2'
                            style={{ width: "30px" }}
                            alt=""
                        />
                        <p style={{ color: "#465060" }} className='m-0 course-section-orange-text'>
                            Auburn University
                        </p>
                    </div>
                    <div className="col-md-4 mb-2 mb-md-0 d-flex align-items-center justify-content-md-center american-dream-course-section">
                        <img
                            src="https://media.publit.io/file/TheWorldgrad/3Institutions/Common/Duration.png"
                            className='mr-2'
                            style={{ width: "30px" }}
                            alt=""
                        />
                        <p style={{ color: "#465060" }} className='m-0 course-section-orange-text'>
                            Course Duration - 4 years
                        </p>
                    </div>
                    <div className="col-md-4 mb-2 mb-md-0 d-flex justify-content-md-end">
                        <a
                            className='course-section-orange-text'
                            href="/program-detail/australia/la-trobe-university/ug/bachelor-of-business-international-business/"
                        >
                            View Details
                        </a>
                    </div>
                    <hr className='course-section-horizontal-line' />
                </div>
            </div>

            <div className="collapse-section py-5">
                <div className="collapse-section-text-area">
                    {/* <span className="collapse-section-text-area-title">What will you study?</span> */}
                    <h3> What will you study? </h3>
                    {/* <span className="collapse-section-text-area-text">Based on your degree choice you will study the following modules over the course of the All American Year 1 program before progressing overseas to your university of choice</span> */}
                    <h6 className='american-dream-section-one-subtext px-3'>
                    Based on your degree choice you will study the following modules over the course of the All American Year 1 program before progressing overseas to your university of choice
                    </h6>
                </div>
                <div className="placerholder-accordion">

                    <Accordion className="customize-accord" defaultExpanded={false}>
                        <AccordionSummary expandIcon={<ExpandMore />} className="customize-accord-common customize-accord-title" >
                        Business/Liberal Arts Stream
                        </AccordionSummary>

                        <AccordionDetails className="customize-accord-body">
                            {
                                collapse.map((e, i) => (
                                    <Accordion defaultExpanded={true} className="customise-accord-color customize-accord">
                                        <AccordionSummary expandIcon={<ExpandMore />} className="customize-accord-common customize-accord-title-title">
                                            {e.title}
                                        </AccordionSummary>

                                        <AccordionDetails className="customize-accord-body-body">
                                            {e.body}
                                        </AccordionDetails>
                                    </Accordion>
                                ))
                            }

                        </AccordionDetails>
                    </Accordion>

                    <Accordion className="customize-accord" defaultExpanded={false}>
                        <AccordionSummary expandIcon={<ExpandMore />} className="customize-accord-common customize-accord-title" >
                        Engineering/Technology Stream
                        </AccordionSummary>

                        <AccordionDetails className="customize-accord-body">
                            {
                                collapse2.map((e, i) => (
                                    <Accordion key={i} defaultExpanded={true} className="customise-accord-color customize-accord">
                                        <AccordionSummary expandIcon={<ExpandMore />} className="customize-accord-common customize-accord-title-title">
                                            {e.title}
                                        </AccordionSummary>

                                        <AccordionDetails className="customize-accord-body-body">
                                            {e.body}
                                        </AccordionDetails>
                                    </Accordion>
                                ))
                            }

                        </AccordionDetails>
                    </Accordion>

                </div>
            </div>

            <AmericanDreamRequirements 
                QualificationInfo={["All India School Certificate (CBSE): Successful completion of AISSCE with an overall GPA starting from 50% or above", "India Higher Secondary School Certificate (State Boards): Average starting from 50% or above"]}
                EnglishRequirements={["IELTS starting from 5.0 or equivalent", "TOEFL score starting from 72 or equivalent"]}
                FeesAndScholarship={["All American Program Fees - INR 7.5 Lacs + GST (24-30 credits)", "University fees starting from USD 23,500 per annum*", "Scholarships up to USD 20,000 per annum*"]}
                imgFile="https://media.publit.io/file/TheWorldgrad/9Programs/AllAmericanYear1Program/IMG-20220107-WA0001.jpg"
                imgHeading="Sample Transcript"
            />

            <section className='py-5' style={{backgroundColor: "#f8f8fa"}}> 
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <h3 className="text-center"> FAQs </h3>
                        </div>
                    </div>
                </div>
                {/* <FaqSection /> */}
                <AmericanDreamFaqSection />
            </section>
            <Footer />
        </div>
        </>
    )
}

export default AmericanDream 

export const WorldGradUniversities = graphql`
    {
        allWordpressWpUniversities(filter: {acf: {country: {eq: "USA"}}}) {
        nodes {
            id
            slug
            title
            acf {
            banner_image {
                source_url
            }
            }
        }
        }
    }
`


